import React from "react";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  ArcElement,
  Legend,
} from "chart.js";
import { Line, Doughnut } from "react-chartjs-2";

ChartJS.register(
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  ArcElement,
  Legend
);

export const LineChartElement = (props) => {
  const labels = getLastMonth();
  const chartdata = {
    labels,
    datasets: [
      {
        label: "Views",
        data: props.data,
        borderColor: "#F0ABFC",
        backgroundColor: "#F0ABFC",
      },
    ],
  };

  const chartoptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Yearly Views",
      },
    },
  };

  return (
    <div>
      {/* <h1>Chart</h1> */}
      <Line options={chartoptions} data={chartdata} />
    </div>
  );
};

export const PieChartElement = (props) => {
  const chartdata = {
    labels: ["Subscriber", "Non Subscriber"],
    datasets: [
      {
        label: "Users",
        data : props.data,
        borderColor: ["#DCDEF4", "#EFF7E2"],
        backgroundColor: ["#DCDEF4", "#EFF7E2"],
      },
    ],
  };

  return (
    <div>
      {/* <h1>Chart</h1> */}
      <Doughnut data={chartdata} />
    </div>
  );
};

function getLastMonth() {
  const labels = [];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "April",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const currentMonth = new Date().getMonth();
  const remain = 11 - currentMonth;

  for (let index = currentMonth; index < months.length; index--) {
    const element = months[index];
    labels.unshift(element);
    if (index === 0) break;
  }

  for (let index = 11; index > remain; index--) {
    if (index === currentMonth) break;
    const element = months[index];
    labels.unshift(element);
  }
  return labels;
}
